(() => {
  const recommendations = {
    together: ['Your match · Together', 'The connection edit', 'Start with versatile, easy-to-share designs that leave plenty of room for conversation, curiosity and discovering what feels good together.'],
    bold: ['Your match · Playful', 'The bold discovery edit', 'Explore expressive shapes, varied sensations and flexible designs made for following your curiosity beyond the familiar.'],
    versatile: ['Your match · Versatile', 'The go-anywhere edit', 'Discover adaptable favourites with intuitive controls and considered forms, chosen to feel at home in solo rituals or shared moments.'],
    gentle: ['Your match · Gentle', 'The soft-start edit', 'Begin with approachable, quietly designed essentials that make it easy to take your time and explore one comfortable step at a time.'],
  };
  function init(root = document) {
    root.querySelectorAll('[data-xr-quiz]').forEach(quiz => {
      if (quiz.dataset.initialized) return;
      quiz.dataset.initialized = 'true';
      const form = quiz.querySelector('form');
      const steps = [...quiz.querySelectorAll('[data-step]')];
      const next = quiz.querySelector('[data-next]');
      const back = quiz.querySelector('[data-back]');
      const result = quiz.querySelector('[data-result]');
      const progress = quiz.querySelector('[data-progress]');
      let index = 0;
      function render() {
        steps.forEach((step, i) => { step.hidden = i !== index; });
        back.hidden = index === 0;
        next.disabled = !steps[index].querySelector('input:checked');
        next.textContent = index === 2 ? 'See my match →' : 'Continue →';
        progress.textContent = `Step ${index + 1} of 3`;
      }
      form.addEventListener('change', render);
      back.addEventListener('click', () => { index = Math.max(0, index - 1); render(); });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!steps[index].querySelector('input:checked')) return;
        if (index < 2) { index++; render(); return; }
        const answers = Object.fromEntries(new FormData(form));
        const key = answers.setting === 'partner' || answers.feeling === 'connection' ? 'together'
          : answers.feeling === 'adventurous' || answers.experience === 'confident' ? 'bold'
          : answers.setting === 'either' || answers.experience === 'familiar' ? 'versatile' : 'gentle';
        ['label', 'title', 'body'].forEach((name, i) => { quiz.querySelector(`[data-result-${name}]`).textContent = recommendations[key][i]; });
        form.hidden = true; progress.hidden = true; result.hidden = false; result.focus();
      });
      quiz.querySelector('[data-restart]').addEventListener('click', () => {
        form.reset(); index = 0; form.hidden = false; progress.hidden = false; result.hidden = true; render();
        steps[0].querySelector('input').focus();
      });
      render();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
